<template>
  <button
      class="serp__filters--mobile-close-button"
      @click="filtersStore.hideFiltersOnMobile"
      aria-label="Zamknij filtry"
  >
    <span class="q-close-icon"></span>
  </button>
</template>

<script setup lang="ts">
import { useFiltersStore } from "@/store/SerpPage/FiltersStore";
const filtersStore = useFiltersStore();
</script>

<style scoped>
.serp__filters--mobile-close-button {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: none;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
  z-index: 50;
}

.serp__filters--mobile-close-button:hover {
  background: rgba(0,0,0,0.05);
}

.q-close-icon {
  position: relative;
  width: 16px;
  height: 16px;
}

.q-close-icon::before,
.q-close-icon::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 2px;
  background-color: #333;
  transform-origin: center;
  transition: background 0.2s ease;
}

.q-close-icon::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.q-close-icon::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.serp__filters--mobile-close-button:hover .q-close-icon::before,
.serp__filters--mobile-close-button:hover .q-close-icon::after {
  background-color: #000;
}
</style>
